import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // Scrolls to the top of the page smoothly when the route (pathname) changes
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [location.pathname]); // Re-run this effect whenever the pathname changes

  return null; // This component doesn't render any UI
};

export default ScrollToTop;